import React from "react";

import { useUi } from "@jelly/lesson";
import { Modal } from "@jelly/ui";
import * as appConfig from "appConfig";

type RecordingsInfoModalProps = Omit<React.ComponentProps<typeof Modal>, "children">;

export const RecordingsInfoModal: React.FC<RecordingsInfoModalProps> = (props) => {
  const ui = useUi();

  return (
    <ui.Modal {...props}>
      <img
        style={{ width: "100%" }}
        src={`${appConfig.STATIC_ASSETS_URL}/lms/case-example/technical-pov/recordings-table.svg`}
        alt={"recordings table"}
      />
    </ui.Modal>
  );
};
